import axios from "axios";

interface DeviceInfo {
  device: string;
  os: string;
  ip: string;
  platform: string;
}

const getDeviceInfo = async (): Promise<DeviceInfo> => {
  // Get OS info
  const userAgent = window.navigator.userAgent;
  const platform = window.navigator.platform;

  let os = "";
  if (userAgent.includes("Win")) os = "Windows";
  else if (userAgent.includes("Mac")) os = "MacOS";
  else if (userAgent.includes("Linux")) os = "Linux";
  else if (userAgent.includes("Android")) os = "Android";
  else if (userAgent.includes("iOS")) os = "iOS";

  // Get device type
  const isMobile = /iPhone|iPad|iPod|Android|webOS|BlackBerry|Windows Phone/i.test(userAgent);
  const isTablet = /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(userAgent);

  let device = "Desktop";
  if (isMobile) device = "Mobile";
  if (isTablet) device = "Tablet";

  try {
    const response = await axios.get<{ ip: string }>("https://api.ipify.org?format=json");

    return {
      device,
      os: `${os} ${platform}`,
      platform,
      ip: response.data.ip,
    };
  } catch (error) {
    console.error("Error fetching IP:", error);
    return {
      device,
      os: `${os} ${platform}`,
      platform,
      ip: "Unknown",
    };
  }
};

export default getDeviceInfo;
